import { createSelector } from 'reselect';
import { RICH_TEXT_ENABLED, RICH_TEXT_EDITOR_DESCRIPTION, VIRTUAL_EVENT_RICH_TEXT_ENABLED } from './constants';

const featureFlagsState = (state) => state.featureFlags || { flags: {}, isFetching: false };

export const getFeatureFlags = createSelector(
  [featureFlagsState],
  (featureFlags) => featureFlags.flags || {}
);

export const isFeatureFlagsFetching = createSelector(
  [featureFlagsState],
  (featureFlags) => featureFlags.isFetching
);

export const isRichTextEnabled = createSelector(
  [getFeatureFlags],
  (flags) => flags[RICH_TEXT_ENABLED] === true
);

export const isRichTextEditorDescriptionEnabled = createSelector(
  [getFeatureFlags],
  (flags) => flags[RICH_TEXT_EDITOR_DESCRIPTION] === true
);

export const isVirtualEventRichTextEnabled = createSelector(
  [getFeatureFlags],
  (flags) => flags[VIRTUAL_EVENT_RICH_TEXT_ENABLED] === true
);

export const getFeatureFlagByName = (state, flagName) => {
  const flags = getFeatureFlags(state);
  return flags[flagName] === true;
};
